const CLOUDFRONT_HOST = process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST;

export const SAVED_SEARCH_MODAL_TRACKING_ID = 'savedsearch';

export const SAVED_SEARCH_MODAL_VIDEO = `${CLOUDFRONT_HOST}/web/assets/savedSearch/saved-search-modal-loop.mp4`;
export const SAVED_SEARCH_MODAL_VIDEO_POSTER = `${CLOUDFRONT_HOST}/web/assets/savedSearch/saved-search-modal-poster.webp`;
